import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import reportWebVitals from './index/reportWebVitals';
import { installImageCdnFallback } from './catalog/ImageCdn';
import './index/css/index.css';
import './components/uiElements/pagination/css/Pagination.css';
import './components/uiElements/socialProfiles/followRow1/css/FollowRow1.css';
import './components/uiElements/socialFeeds/instagramFeed1/css/InstagramFeed1.css';
import './components/uiElements/socialFeeds/youtubeFeed1/css/YoutubeFeed1.css';
import './components/uiElements/socialFeeds/socialPlatformLinks/css/SocialPlatformLinks.css';
// Shared by the player, coach and staff cards; imported once here so per-chunk CSS order can't conflict (CI build).
import './components/uiElements/profileCards/profileCard1/css/ProfileCard1.css';
// Shared by the event and practice rows (EventRowCard1); global for the same CSS-order reason.
import './components/uiElements/eventAndPracticeThumbnails/eventRowCard1/css/EventRowCard1.css';
// Ticket purchase screen (TicketPurchase1), rendered by two components from different chunks.
import './components/uiElements/ticketsComponents/ticketComponent1/css/TicketPurchase1.css';
// Product tile (ProductTile1), rendered by four product thumbnail variants.
import './components/uiElements/productThumbnails/productTile1/css/ProductTile1.css';
// Outline More button (MoreButton1), used by the homepage About and Upcoming sections.
import './components/uiElements/buttons/css/MoreButton1.css';
// Phone article rows + lead card (ArticleRow1 / ArticleLeadCard1), used by the Articles page and the homepage news.
import './components/uiElements/articleThumbnails/articleRow1/css/ArticleRow1.css';
// OT / SO marker next to final scores (GameEndingTag1), used by every games widget and the game page.
import './components/uiElements/gamesWidgets/gameEndingTag1/css/GameEndingTag1.css';
import './components/uiElements/calendarBanner/calendarBanner1/css/CalendarBanner1.css';
import './components/uiElements/shareComponents/shareComponent1/css/ShareComponent1.css';

// Before the first render: a failed /.netlify/images image falls back to its Firebase URL.
installImageCdnFallback();

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
